import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

import { createSectionList } from "lib/build/dashboards/htx";
import { SectionDescriptor } from "lib/build/dashboards/shared";
import { EventsState } from "lib/build/events";
import { createIntlContext, translations } from "lib/build/intl";

export function useSectionList(): SectionDescriptor[] {
	const { locale } = useIntl();
	const intl = React.useMemo(
		() => createIntlContext(translations, locale),
		[locale]
	);
	const { items: events } = useSelector(
		({ events }: { events: EventsState }) => events
	);
	return React.useMemo(
		() => createSectionList(intl, { events }),
		[intl, events]
	);
}
